import { RSFSettings } from "../rsf-settings";



export class RSFSettingsRefresh {
  static readonly type = '[RSFSettings] Refresh';
}

export class RSFSettingsRefreshById {
  static readonly type = '[RSFSettings] RefreshById';
  constructor(public id: number) { }
}

export class RSFSettingsCreate {
  static readonly type = '[RSFSettings] Create';

  constructor(public item: RSFSettings) { }
}

export class RSFSettingsUpdate {
  static readonly type = '[RSFSettings] Update';

  constructor(public id: number, public item: RSFSettings) { }
}

export class RSFSettingsDelete {
  static readonly type = '[RSFSettings] Delete';
  constructor(public id: number) { }
}
